import React from "react";
import { FaInstagram, FaGithub } from 'react-icons/fa';
import {Ftr,FooterContainer,Caption,CaptionSocial} from '../../styles/Footer-Styles';
const Footer = () => {
    var date = new Date();
  var year = date.getFullYear();
  return(
      <Ftr>
          <FooterContainer>
          <Caption>{`Swapnil Rawat © ${`${year} all rights reserved`}`}</Caption>
          <CaptionSocial>
          <a href="http://www.instagram.com/swapnilr17"><FaInstagram style={{color:'white'}}/></a><a href="http://www.instagram.com/swapnilr17"><FaGithub style={{color:'white'}}/></a>
        </CaptionSocial>
          </FooterContainer>
      </Ftr>
  );
};

export default Footer;